import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Button } from "components"
import { haveAuth, ObjectValues } from "utils"
import classes from "./PoGroupLabelPrintButton.module.scss"

const PoGroupLabelPrintButton = props => {
  const { selectedOrders } = props

  const [t, i18n] = useTranslation()

  const [sending, setSending] = useState(false)

  const handlePrintOrders = async () => {
    setSending(true)

    sessionStorage.setItem(
      "data",
      JSON.stringify({
        type: "courier",
        value: orders
      })
    )

    window.open(`/print`, "_blank")

    setSending(false)
  }

  const orders =
    ObjectValues(selectedOrders)

  const showPrintButton =
    orders.length > 0 &&
    haveAuth(["printerAccess"])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  if (!showPrintButton) return null

  return (
    <Button
      loading={sending}
      color="warning"
      onClick={handlePrintOrders}
      className={clsx(
        classes["button"],
        isLtr && classes["button-ltr"]
      )}
    >
      {t("پرینت_لیبل_سفارشات")}
    </Button>
  )
}

export default PoGroupLabelPrintButton